<div class="container">
  <form class="filter-container" [formGroup]="formGroup">
    <div class="p-fluid security-wrapper">
      <div class="full-width-security">
        <app-security-reference-search
          [isMandatory]="true"
          [includeAllSecurities]="false"
          label="Security Code"
          formControlName="securityId"
        ></app-security-reference-search>
      </div>
    </div>

    <div class="p-fluid flex">
      <app-fy-calender
        label="Date Range"
        [isMandatory]="true"
        [initialValue]="dateRange"
        [dropdown]="{ includeAll: true, isAllFY: false }"
        (onChange)="onChangeDates($event)"
        [style]="{ width: '16rem' }"
      />
    </div>

    <div class="p-fluid full-space">
      <span class="p-float-label">
        <p-dropdown
          formControlName="filterDate"
          [options]="filterDateOptions"
          optionValue="value"
          optionLabel="label"
          [style]="{ width: '16rem' }"
        ></p-dropdown>
        <label for="filterDate"><span style="color: red; font-size: larger">*</span>Filter Date</label>
      </span>
    </div>

    <div class="btn-container">
      <span class="p-buttonset ">
        <button
          pButton
          class="p-button-outlined p-button-primary p-fluid"
          label="Confirm"
          (click)="onConfirm()"
          icon="pi pi-check-circle"
          [disabled]="!isFormValid"
        ></button>
        <button
          pButton
          class="p-button-outlined p-button-danger"
          label="Reset"
          (click)="onReset()"
          icon="pi pi-refresh"
          [disabled]="isFormDirty"
        ></button>
      </span>
    </div>
  </form>

  <div *ngIf="formGroup.value.filterDate === 'payDate' || formGroup.value.filterDate === 'taxReportDate'" class="note-container">
    <p style="font-style: italic">
      * Note: The {{ formGroup.value.filterDate === 'payDate' ? 'pay date' : 'tax report date' }} filter will only be applied to dividends only
    </p>
  </div>
</div>
